import UserType from '../Models/UserType';
import DataGridRequest from './DataGridRequest';
export class UserTypeRequest extends DataGridRequest<UserType> {
    Url = '/api/v1/account/users';
}
